import { Skeleton, Typography } from '@mui/material'
import { APIError } from 'components/core/errors/api'
import { InsightItem } from 'components/core/insights'
import { GetAttributeValuesRequest } from 'pbts/c1/api/attribute/v1/attribute'
import { InsightType, ComplianceFrameworkInsight } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getAttributesApi } from 'redux_toolkit/attributes'

type ComplianceFrameworkLabelProps = {
    complianceFramework: ComplianceFrameworkInsight
}

const ComplianceFrameworkLabel: FC<ComplianceFrameworkLabelProps> = ({ complianceFramework }) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = getAttributesApi.useGetAttributeValues(
        GetAttributeValuesRequest.create({
            attributeIds: complianceFramework.complianceFrameworkIds,
        }),
    )
    if (isLoading) {
        return <Skeleton variant="text" />
    }
    if (isError) {
        return <APIError err={error} />
    }
    if (!data || data.items.length === 0) {
        return null
    }
    return (
        <Typography>
            <FormattedMessage
                id="components_insights_complianceFramework"
                defaultMessage="This entitlement is part of <b>{compliance_frameworks}</b>"
                values={{
                    b: (chunks) => <b>{chunks}</b>,
                    compliance_frameworks: data.items.map((item) => item.value).join(', '),
                }}
            />
        </Typography>
    )
}

export type ComplianceFrameworkProps = {
    complianceFramework: ComplianceFrameworkInsight
    insightType: InsightType
}

export const ComplianceFramework: FC<ComplianceFrameworkProps> = ({ complianceFramework, insightType }) => {
    return (
        <InsightItem key="compliance_framework_item" insightType={insightType}>
            <ComplianceFrameworkLabel complianceFramework={complianceFramework} />
        </InsightItem>
    )
}
